"use strict";
exports.__esModule = true;
exports.APIResponse = void 0;
var APIResponse = /** @class */ (function () {
    function APIResponse(success, data, message, // Optional in success, mandatory in error
    error_code, // Standard HTTP status code (e.g., 401, 404, 500)
    meta_data // Optional: pagination, debug info, etc.
    ) {
        this.success = success;
        this.data = data;
        this.message = message;
        this.error_code = error_code;
        this.meta_data = meta_data;
    }
    APIResponse.success = function (data, meta_data) {
        return new APIResponse(true, data, undefined, undefined, meta_data);
    };
    APIResponse.error = function (message, error_code) {
        if (error_code === void 0) { error_code = 500; }
        return new APIResponse(false, undefined, message, error_code);
    };
    return APIResponse;
}());
exports.APIResponse = APIResponse;
